let menuActive = false
let submenusInit = false
const flyoutBreakpoint = 980
const hasChildrenSelector = '.franchiseMainMenu__item--hasChildren'

const isAboveBreakpoint = (breakpoint) => {
    return !!matchesMediaQuery(breakpoint)
}

const handleFlyoutButtonClick = () => {
    if (isAboveBreakpoint(flyoutBreakpoint + 1)) {
        return (menuActive = false)
    }

    menuActive = !menuActive
    document.documentElement.classList.toggle('noScroll')
    document.body.classList.toggle('franchiseFlyoutOpen')
}

const createItemAndInsert = (a, submenu) => {
    const item = document.createElement('li')
    item.classList.add('js_cloned')
    item.appendChild(a)
    submenu.prepend(item)
}

const initClickableSubmenus = (items) => {
    items.forEach((item) => {
        const anchor = item.querySelector('a')
        anchor.addEventListener('click', onSubmenuParentClick)

        const clonedAnchor = anchor.cloneNode(true)
        const submenu = item.querySelector('ul')
        createItemAndInsert(clonedAnchor, submenu)
    })

    submenusInit = true
}

const destroyClickableSubmenus = (items) => {
    items.forEach((item) => {
        if (item.classList.contains('franchiseMainMenu__item--open')) {
            item.classList.remove('franchiseMainMenu__item--open')
        }

        item.querySelector('a').removeEventListener(
            'click',
            onSubmenuParentClick
        )

        const cloned = item.querySelector('.js_cloned')

        console.log({ cloned })

        item.querySelector('.js_cloned').remove()
    })

    submenusInit = false
}

const onSubmenuParentClick = (e) => {
    e.preventDefault()

    const parent = e.target.closest('li')
    parent.classList.toggle('franchiseMainMenu__item--open')
}

const initFlyoutClass = () => !document.body.classList.contains('franchiseFlyoutInit') && document.body.classList.add('franchiseFlyoutInit')

$(document).ready(() => {
    const triggers = document.querySelectorAll('.js_franchiseFlyoutButton')
    triggers.forEach((b) =>
        b.addEventListener('click', handleFlyoutButtonClick)
    )

    if (!isAboveBreakpoint(flyoutBreakpoint + 1)) {
        initClickableSubmenus(document.querySelectorAll(hasChildrenSelector))
        initFlyoutClass()
    }

    if ($('.js_franchiseHeader__contact__trigger').length) {
        $('.js_franchiseHeader__contact__trigger').on('click', function() {
            $(this).parent('.franchiseHeader__actionLink--contact').toggleClass('franchiseHeader__actionLink--active')
        })
    }
})

$(window).on(
    'resize',
    debouncer((e) => {
        'use strict'

        // check if above breakout, then remove the classes to show the menu
        if (isAboveBreakpoint(flyoutBreakpoint + 1)) {
            document.documentElement.classList.contains('noScroll') &&
            document.documentElement.classList.remove('noScroll')

            document.body.classList.contains('franchiseFlyoutOpen') &&
            document.body.classList.remove('franchiseFlyoutOpen')

            document.body.classList.contains('franchiseFlyoutInit') &&
            document.body.classList.remove('franchiseFlyoutInit')

            if (submenusInit) {
                destroyClickableSubmenus(
                    document.querySelectorAll(hasChildrenSelector)
                )
            }
        } else {
            initFlyoutClass()

            if (!submenusInit) {
                initClickableSubmenus(
                    document.querySelectorAll(hasChildrenSelector)
                )
            }
        }
    })
)
